var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "section",
        { staticClass: "catalogue-banner-section" },
        [
          _c("content-creator", {
            key: _vm.catalogueHeaderBlobID,
            staticClass: "header-carousel",
            attrs: {
              settings: _vm.getBlobContents(_vm.catalogueHeaderBlobID),
              permissions: _vm.contentCreatorPermissions,
              "is-visible": _vm.editContentCreator,
              filestore: _vm.websitefilestore,
              name: _vm.catalogueHeaderBlobID,
              "allowed-widgets": "carousel,content-list,content-grid",
            },
            on: {
              updateBlob: (data) =>
                _vm.saveBlob(_vm.catalogueHeaderBlobID, data),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c("route-catalog", {
                    attrs: {
                      filters: _vm.WineCatalogFilters,
                      sorters: _vm.WineCatalogSorters,
                    },
                    model: {
                      value: _vm.settings,
                      callback: function ($$v) {
                        _vm.settings = $$v
                      },
                      expression: "settings",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }